export default __webpack_public_path__ + "static/media/B199.7169bb11.png";